import type { LinkValue } from '@elfsight/configurator-contracts';
import { ensureProtocol } from '@elfsight/lib-utils';
import type { OpenWindowOptions } from './open-window';
import { openWindow } from './open-window';
import { validateLink } from './validate-link';

export function openWindowByLink(
  event: React.MouseEvent<Element, MouseEvent>,
  link: LinkValue,
  openWindowOptions?: Omit<OpenWindowOptions, 'target'>
) {
  event.preventDefault();

  const { type, rawValue, target } = link;
  const isValidLink = validateLink(type, rawValue);

  if (!isValidLink) {
    return null;
  }

  const validateURL = ensureProtocol(rawValue);

  return openWindow(validateURL, { target, ...openWindowOptions });
}
